import { ProjectContract } from '@app/_models/project-contract.model';
import {
  ArchitecturalBureauReferencesDTO
} from "@app/admin/architectural-bureau-references/dto/architectural-bureau-references-dto";

export class ProjectInfo {
  id!: string;
  name!: string;
  shortName!: string;
  objectType?: string;
  region?: string;
  address?: string;
  notificationNumber?: string;
  notificationDate?: any;
  startDate?: any;
  endDate?: any;
  kenML?: boolean;
  manualCompleteAct?: boolean;
  taskTimerValue?: number;
  solidWasteContract?: ProjectContract;
  builderContract?: ProjectContract;

  locked?: boolean;
  lockedBy?: string;
  lockedByFullName?: string;
  lockedDate?: any;
  lockedLevel?: string;
  lockedReason?: string;
  lockedReasonNotes?: string;

  investors?: any[];
  builders?: any[];
  designers?: any[];
  technicalSupervisions?: any[];
  designSupervisions?: any[];

  totalVolume?: number;
  totalPrice?: number;
  closedVolume?: number;
  closedPrice?: number;
  closedPercent?: number;

  status?: string;
  completedDate?: string;
  deletedDate?: string;
  createDate?: string;

  reviewActTimerValue?: number;
  completeActTimerValue?: number;
  executiveActTimerValue?: number;
  completeReferenceTimerValue?: number;
  supervisionCompleteActTimerValue?: number;
  supervisionCompleteReferenceTimerValue?: number;
  completeCalculationTimerValue?: number;
  completeConclusionTimerValue?: number;
  weeklyReportTimerValue?: number;
  monthlyReportTimerValue?: number;

  abp?: ArchitecturalBureauReferencesDTO;
}
